import type { AppEnvironment } from 'venn-api';
import { getRuntimeConfig } from '../runtime-config';

/**
 * Every product analytics credential lives in this file. All of them are public client-side ids that ship
 * in the bundle regardless, so they are checked in the way DD_CLIENT_TOKEN is.
 *
 * The environment is resolved at runtime: one build is promoted through every environment, so every
 * environment's ids are in the bundle and the deployed config.js decides which one is used.
 *
 * An empty value leaves that provider unloaded.
 */

/** Intercom has no workspace of its own below staging, so every lower environment shares the staging one. */
const INTERCOM_APP_IDS: Record<AppEnvironment, string> = {
  production: 'dxz87xqh',
  staging: 'hrnhb9mn',
  development: 'hrnhb9mn',
  'pr-preview': 'hrnhb9mn',
  local: '',
};

/** One Appcues account serves every environment, so it is not selected per environment. */
const APPCUES_ACCOUNT_ID = '48977';

/**
 * The Universal Analytics properties these replace (UA-96140105-1 and -2) stopped processing data in July
 * 2023, so these are GA4 measurement ids and there is no historical data behind them.
 */
const GA4_MEASUREMENT_IDS: Record<AppEnvironment, string> = {
  production: '',
  staging: '',
  development: '',
  'pr-preview': '',
  local: '',
};

const readConfiguredValue = (value: string): string | undefined => (value === '' ? undefined : value);

export const getIntercomAppId = (): string | undefined => readConfiguredValue(INTERCOM_APP_IDS[getRuntimeConfig().env]);

export const getAppcuesAccountId = (): string | undefined => readConfiguredValue(APPCUES_ACCOUNT_ID);

export const getGa4MeasurementId = (): string | undefined =>
  readConfiguredValue(GA4_MEASUREMENT_IDS[getRuntimeConfig().env]);
